import { usePB } from '@/composables/database/use-pocket-base.ts';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

export function loggedInGuard(to: RouteLocationNormalizedGeneric) {
  const pb = usePB();
  if (!pb.isLoggedIn.value) {
    return { path: '/auth', query: { redirectUrl: to.fullPath } };
  }
}
